// Test IDs for the closed-beta invitation acceptance flow (Build 6, Phase 6.1).
// See ./index.js for the recipe. Keys camelCase; values kebab-case.

export const BETA_INVITE = {
        page: 'beta-invite-page',
        loading: 'beta-invite-loading',
        invalid: 'beta-invite-invalid',
        emailFixed: 'beta-invite-email-fixed',
        capability: 'beta-invite-capability',
        passwordInput: 'beta-invite-password-input',
        displayNameInput: 'beta-invite-display-name-input',
        ageBandSelect: 'beta-invite-age-band-select',
        submitButton: 'beta-invite-submit-button',
        termsCheckbox: 'beta-terms-checkbox',
        termsToggle: 'beta-terms-toggle',
        termsBody: 'beta-terms-body',
        privacyToggle: 'beta-privacy-toggle',
        privacyBody: 'beta-privacy-body',
        success: 'beta-invite-success',
        loginLink: 'beta-invite-login-link',
};
